module.exports = __webpack_public_path__ + "img/ring_r_c_0_0@3x.e3ddaaba.png";